/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// actions
import { setContentType } from 'state/actions/embedsState/embedManagementState/content_status';
import { sendMessage } from 'utils/messages';
import { connect } from 'react-redux';
// actual presentational component that will utilize application state and actions (will be exported after being infused with state/actions)
import EmbedEditor from 'pages/dashboard/embeds/management/customize/embededitor/embededitor';



/* ========== ~~~~~~~~~~ EMBED EDITOR : PARENT ~~~~~~~~~~ ========== */
// CONTAINER COMPONENT
// interacts with redux (store of application state)
// infuses child component (imported above) with state & actions by mapping and then connecting them

// map state
const mapStateToProps = ({ embedsState }) => {
    const contentStatus = embedsState.embedManagementState.contentStatus;
    const activeContents = Object.values(contentStatus.contents).filter(content => content.contentLive === true);
    const inactiveContents = Object.values(contentStatus.contents).filter(content => content.contentLive === false);
    return {
        queuePosition: contentStatus.contents[contentStatus.selectedContent] ? contentStatus.contents[contentStatus.selectedContent].queuePosition + 1 : 0,
        location: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.location,
        contentType: !contentStatus.noLiveContents ? contentStatus.contents[contentStatus.selectedContent].contentType : null,
        questionFormat: !contentStatus.noLiveContents ? contentStatus.contents[contentStatus.selectedContent]['questionBased'].type : null,
        selectedContent: contentStatus.selectedContent,
        numberOfActiveContents: activeContents.length,
        numberOfInactiveContents: inactiveContents.length,
        totalNumberOfContents: Object.keys(contentStatus.contents).length,
        noLiveContents: contentStatus.noLiveContents,
        contents: Object.keys(contentStatus.contents).length > 0
    }
};

const mapDispatchToProps = dispatch => ({
    setContentType: contentType => dispatch(setContentType(contentType)),
    sendMessage: message => dispatch(sendMessage(message))
});

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// utilizes "connect" functionality from redux in order to infuse state/actions as props to child component
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EmbedEditor);
